import { ColumnType } from '../types/Column';
import { styled } from '../../Theme/theme';
import hexagonOpened from '../../../../static/icons/hexagonCheck/opened.svg';
import hexagonClosed from '../../../../static/icons/hexagonCheck/closed.svg';
import dragIcon from '../../../../static/icons/menu.svg';

type DragOverlayItemProps = {
    item: ColumnType<any>;
};

export const DragOverlayItem = ({ item }: DragOverlayItemProps) => {
    return (
        <OverlayItem>
            <Flex>
                <Checkmark
                    src={item.isDisplayed === false ? hexagonOpened : hexagonClosed}
                    alt="hexagon"
                />
                <div>{item.title || item.field}</div>
            </Flex>
            <DragIcon className="drag-icon" src={dragIcon} alt="drag" />
        </OverlayItem>
    );
};

const OverlayItem = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 35px;
    padding: 0 10px;
    background-color: white;
    border: 1px solid #e0e0e0;
    border-radius: 4px;
    box-shadow: 0 6px 9px 0 rgba(0, 0, 0, 0.1);
    user-select: none;
    pointer-events: none;
    transform: rotate(2deg);
    opacity: 0.9;
    z-index: 99999;
    position: relative;
`;

const Flex = styled.div`
    display: flex;
    align-items: center;
`;

const Checkmark = styled.img`
    margin-right: 15px;
`;

const DragIcon = styled.img`
    margin-right: 10px;
    opacity: 0.5;
`;
